import { render, staticRenderFns } from "./hookRule.vue?vue&type=template&id=33435546&scoped=true&"
import script from "./hookRule.vue?vue&type=script&lang=ts&"
export * from "./hookRule.vue?vue&type=script&lang=ts&"
import style0 from "./hookRule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./hookRule.vue?vue&type=style&index=1&id=33435546&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33435546",
  null
  
)

export default component.exports